export const PROCESS_STATUS = {
	SUCCESS: 'success',
	WRONG: 'wrong',
	NONE: 'none',
	SELECTED: 'selected',
	HIDE: 'hide',
};
